var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoseFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DB748"
    },
    d: "M354.846,371.83c0,0-39.072-2.473-64.964,18.503c-25.891,20.974-33.883,61.578-33.883,61.578 s41.377,0.605,67.269-20.37C349.159,410.565,354.846,371.83,354.846,371.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91A842"
    },
    d: "M354.846,371.83l-98.847,80.081c0,0,41.377,0.605,67.269-20.37 C349.159,410.565,354.846,371.83,354.846,371.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DB748"
    },
    d: "M157.152,416.352c0,0,39.072-2.473,64.964,18.503c25.891,20.974,33.883,61.578,33.883,61.578 s-41.377,0.605-67.269-20.37C162.84,455.087,157.152,416.352,157.152,416.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91A842"
    },
    d: "M157.152,416.352l98.847,80.081c0,0-41.377,0.605-67.269-20.37 C162.84,455.087,157.152,416.352,157.152,416.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DB748"
    },
    d: "M260.301,297.717c0,19.405-30.945,44.659-89.401,44.659c12.848-18.898,26.38-50.03,26.38-56.762 L260.301,297.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91A842"
    },
    d: "M251.697,297.717c0,19.405,30.945,44.659,89.401,44.659c-12.848-18.898-26.38-50.03-26.38-56.762 L251.697,297.717z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.542,
    y: 286.653,
    style: {
      fill: "#9DB748"
    },
    width: 26.913,
    height: 225.347
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.999,
    y: 286.653,
    style: {
      fill: "#91A842"
    },
    width: 13.457,
    height: 225.347
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A82667"
    },
    d: "M266.388,31.541C243.559,7.009,199.638,0,199.638,0c-0.683,34.19-20.415,53.139-20.415,53.139 v113.581h87.165V31.541H266.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B82971"
    },
    d: "M326.401,52.62c0,0-1.809-17.755-0.259-34.84c0,0-79.231,1.595-109.706,56.871v75.315h109.965V52.62z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C42C78"
    },
    d: "M148.47,38.98c5.896,19.145,23.896,83.006,1.791,140.446h89.604V94.171 C213.883,65.449,148.47,38.98,148.47,38.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D02D7F"
    },
    d: "M363.635,38.98c-4.904,15.888-25.79,73.168-3.685,130.609 c22.106,57.441,39.533,141.55-103.896,141.55c-44.391,0-83.473-8.802-101.434-29.215c-32.897-37.389-15.909-102.437,24.604-143.863 C230.711,85.412,352.333,42.194,363.635,38.98z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoseFull);
export default __webpack_public_path__ + "static/media/rose-full.24d2857fb904b2c311984b049d559c13.svg";
export { ForwardRef as ReactComponent };